import {
  HospitalizationDto,
  UserMemberStatusDto,
} from '@act/shared/data-transfer-objects';
import { ColumnConfiguration, TaggableChip, IconLibrary } from '@act/storybook';
import { DateTime } from 'luxon';
import { StatusTag } from 'toolkit/tags/status-tags';

interface HospitalizationTableProps extends HospitalizationDto {
  memberStatus: UserMemberStatusDto;
  memberName: string;
  assignedGuide: string;
}

export const HOSPITALIZATION_TABLE_COLUMN_CONFIGURATIONS: ColumnConfiguration<HospitalizationTableProps>[] =
  [
    {
      title: 'Member',
      id: 'memberName',
      value: 'memberName',
      isNumeric: false,
      shouldDisablePadding: false,
    },
    {
      id: 'memberStatus',
      value: (props): React.ReactNode => {
        return <StatusTag status={props?.memberStatus} />;
      },
      isNumeric: false,
      shouldDisablePadding: false,
      title: 'Status',
    },
    {
      title: 'Assigned Guide',
      id: 'assignedGuide',
      value: 'assignedGuide',
      isNumeric: false,
      shouldDisablePadding: false,
      sortable: true,
    },
    {
      title: 'Admit Date',
      id: 'admitDate',
      isNumeric: true,
      shouldDisablePadding: false,
      sortable: true,
      value: (props: HospitalizationDto) => {
        // format: MM/dd/yy
        return DateTime.fromFormat(props.admitDate, 'yyyy-MM-dd').toFormat(
          'MM/dd/yy'
        );
      },
    },
    {
      title: 'Discharge Date',
      id: 'dischargeDate',
      isNumeric: true,
      shouldDisablePadding: false,
      sortable: true,
      value: (props: HospitalizationDto) => {
        if (!props.dischargeDate) {
          return 'N/A';
        }
        const dateString = DateTime.fromFormat(
          props.dischargeDate,
          'yyyy-MM-dd'
        ).toFormat('MM/dd/yy');
        return (
          <div
            style={{
              display: 'flex',
              alignItems: 'center',
              gap: '4px',
              justifyContent: 'end',
            }}
          >
            {dateString}
            {props.isAssumed ? (
              <IconLibrary
                iconName="SealCheck"
                size={24}
                style={{ visibility: 'hidden' }}
                aria-hidden="true"
              />
            ) : (
              <IconLibrary
                iconName="SealCheck"
                size={24}
                aria-label="Verified discharge date"
              />
            )}
          </div>
        );
      },
    },

    {
      title: 'Hospitalization Type',
      isNumeric: false,
      shouldDisablePadding: false,
      id: 'followUpType',
      value: (props: HospitalizationDto) => {
        const isBehavioralHealth = !!props.followUpType;
        if (isBehavioralHealth) {
          return (
            <TaggableChip isTag color="neutral" label="Behavioral Health" />
          );
        } else {
          return <TaggableChip isTag color="neutral" label="Medical" />;
        }
      },
      sortable: true,
    },
  ];
